import React, { useState } from 'react'
import classnames from 'classnames'

import styles from './Button.module.css'
import { NavLink } from 'react-router-dom'

export const Button = ({ route = '#', text, children, bg = true }) => {
	const [isActiveLink, setIsActiveLink] = useState(false)

	let btnClass = isActive => {
		setIsActiveLink(isActive)
		return classnames(styles.Button, isActive ? styles.ButtonActive : '')
	}
	//     if (props.currentRoute === link.route) className = styles.ButtonActive;
	return (
		<NavLink className={({ isActive }) => btnClass(isActive)} to={route} title={text}>
			{React.cloneElement(children, { isActive: isActiveLink })}
			<p>{text}</p>
		</NavLink>
	)
}
